import brickLayerInit from './components/bricklayerstuffagain';
import initCookieNotice from './components/cookienotice';

function initPage() {

    // Stick nav on scroll
    $(window).bind('scroll', function() {
        var headerHeight = $('.logo').height() + 20;

        $(window).resize(function(){
            var somevar = $('.logo').height() + 20;
        });

        if ($(window).scrollTop() > headerHeight) {
            $('.site-nav').addClass('is-fixed');
            $('.site-main').css('margin-top', '5rem');
        } else {
            $('.site-nav').removeClass('is-fixed');
            $('.site-main').css('margin-top', '0');

        }
    });

// When mobile navigation is opened
    $('.menu-opener').on('click', function() {
        $('.site-nav').toggleClass('is-opened');
        $('.menu').slideToggle(250);
    });

// When navigation link is clicked
    $('.menu-link').on('click', function() {
        if ($(window).width() < 786) {
            $('.site-nav').removeClass('is-opened');
            $('.menu').slideUp(250);
        }
    });

// When navigation link is clicked
    $('.impressum').on('click', function() {
        $('.section-10').slideToggle(250);
        $('html,body').animate({scrollTop: $(this).offset().top},500);
        $(this).addClass('current').unbind('click');
    });

// Internal smooth scroll
    $(function() {
        $('a[href*="#"]:not([href="#"])').click(function() {
            if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
                if (target.length) {
                    $('html, body').animate({
                        scrollTop: target.offset().top
                    }, 1000);
                    return false;
                }
            }
        });
    });

    brickLayerInit();
    initCookieNotice();
};


$(document).ready(function () {
    initPage();
});

// $('.bricklayer').imagesLoaded( function() {
//     brickLayerInit();
// });



// WEBPACK FOOTER //
// ./main.js